var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _c("h1", [_vm._v(_vm._s(_vm.category.name))]),
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  _vm.showAddSubcategoryModal = true
                },
              },
            },
            [_vm._v(" Add Subcategory ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _c("h5", [_vm._v("Search Subcategory")]),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("b-form-input", {
                staticClass: "mr-2",
                attrs: { placeholder: "Search subcategories..." },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(
                "b-button",
                {
                  attrs: { disabled: !_vm.search },
                  on: { click: _vm.clearSearch },
                },
                [_vm._v("Clear")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: { label: "Per Page:", "label-for": "per-page-select" },
            },
            [
              _c("b-form-select", {
                attrs: {
                  id: "per-page-select",
                  options: _vm.pageOptions,
                  size: "sm",
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          striped: "",
          hover: "",
          items: _vm.filteredSubCategories,
          fields: _vm.fields,
          "per-page": _vm.perPage,
          "current-page": _vm.currentPage,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (data) {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: {
                      variant: "link",
                      "toggle-class": "text-decoration-none",
                      "no-caret": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c("feather-icon", {
                                staticClass: "text-body align-middle mr-25",
                                attrs: { icon: "MoreVerticalIcon", size: "16" },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editSubcategory(data.item)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "EditIcon" },
                        }),
                        _c("span", [_vm._v("Edit")]),
                      ],
                      1
                    ),
                    _c(
                      "b-dropdown-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.removeSubcategory(data.item)
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "TrashIcon" },
                        }),
                        _c("span", [_vm._v("Delete")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-addsubcategory",
            title: "Add Subcategory",
            "hide-footer": "",
            centered: "",
          },
          model: {
            value: _vm.showAddSubcategoryModal,
            callback: function ($$v) {
              _vm.showAddSubcategoryModal = $$v
            },
            expression: "showAddSubcategoryModal",
          },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addSubcategory($event)
                },
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Subcategory Name",
                    "label-for": "subcategoryName",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "subcategoryName",
                      placeholder: "Enter subcategory name",
                    },
                    model: {
                      value: _vm.newSubcategoryName,
                      callback: function ($$v) {
                        _vm.newSubcategoryName = $$v
                      },
                      expression: "newSubcategoryName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.showAddSubcategoryModal = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "b-button",
                    { attrs: { type: "submit", variant: "primary" } },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticClass: "mx-2",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                      _vm._v("Save "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-editsubcategory",
            title: "Edit Subcategory",
            "hide-footer": "",
            centered: "",
          },
          model: {
            value: _vm.showEditSubcategoryModal,
            callback: function ($$v) {
              _vm.showEditSubcategoryModal = $$v
            },
            expression: "showEditSubcategoryModal",
          },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateSubcategory($event)
                },
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Subcategory Name",
                    "label-for": "editSubcategoryName",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "editSubcategoryName",
                      placeholder: "Enter new subcategory name",
                    },
                    model: {
                      value: _vm.editSubcategoryName,
                      callback: function ($$v) {
                        _vm.editSubcategoryName = $$v
                      },
                      expression: "editSubcategoryName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.showEditSubcategoryModal = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "b-button",
                    { attrs: { type: "submit", variant: "primary" } },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }